import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    desktopSrc: String,
    mobileSrc: String,
    breakpoint: { type: Number, default: 640 },
  };

  connect() {
    this.mediaQuery = window.matchMedia(
      `(min-width: ${this.breakpointValue}px)`,
    );
    this.onChange = () => this.loadVideo();
    this.mediaQuery.addEventListener("change", this.onChange);
    this.loadVideo();
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.onChange);
  }

  loadVideo() {
    const src = this.mediaQuery.matches
      ? this.desktopSrcValue
      : this.mobileSrcValue;
    if (this.element.getAttribute("src") === src) return;

    this.element.src = src;
    this.element.load();
    this.element.play().catch(() => {});
  }
}
